/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FacilityCustomTagFacility
 */
export interface FacilityCustomTagFacility {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the FacilityCustomTagFacility interface.
 */
export function instanceOfFacilityCustomTagFacility(value: object): value is FacilityCustomTagFacility {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FacilityCustomTagFacilityFromJSON(json: any): FacilityCustomTagFacility {
    return FacilityCustomTagFacilityFromJSONTyped(json, false);
}

export function FacilityCustomTagFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityCustomTagFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FacilityCustomTagFacilityToJSON(json: any): FacilityCustomTagFacility {
    return FacilityCustomTagFacilityToJSONTyped(json, false);
}

export function FacilityCustomTagFacilityToJSONTyped(value?: FacilityCustomTagFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

